export type Truthy<T> = T extends boolean | 0 | undefined | null | ''
  ? never
  : T;
export const truthyFilter = <T>(value: T): value is Truthy<T> => !!value;
export const isNumber = (candidate: unknown): candidate is number =>
  typeof candidate === 'number' && !Number.isNaN(candidate);
